import { useSelector } from 'react-redux';

import { AUTHENTICATION_STATUS } from '../legacy/constants';
import { isDataLoadedToInitApp } from '../legacy/selectors';

// Whether the visitor has a real, fully-loaded hub session — same condition
// ProtectedRoute gates on. Pages reachable without a hub login (e.g. the
// tokenised session report) use this to decide whether it's safe to run
// authenticated-only queries (account details, subscription, etc.) rather
// than assuming every app-shell consumer is logged in.
export function useIsHubAuthenticated() {
  const authenticationStatus = useSelector((state: { login: { authenticationStatus: string } }) => {
    return state.login.authenticationStatus;
  });
  const dataReady = useSelector(isDataLoadedToInitApp);

  return authenticationStatus === AUTHENTICATION_STATUS.AUTHENTICATED && dataReady;
}
